import { defineComponent as _defineComponent } from 'vue'
import { format_datetime, format_datetime_short } from "@/utils";

// Props
type PropTypes = {
  last_modified: string;
  saving?: boolean;
  short?: boolean;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'last_saved',
  props: {
    last_modified: null,
    saving: { type: Boolean, default: false },
    short: { type: Boolean, default: true }
  },
  setup(__props: any) {

const props = __props as { last_modified: string, saving: boolean, short: boolean };



// Make utility functions available to template
const { last_modified, saving, short } = props;

return { __sfc: true,props, last_modified, saving, short, format_datetime, format_datetime_short }
}

})